<template>
  <div class="profit-loss-year">
    <div class="section operations" style="margin-bottom:1px;">
      <el-form inline style="margin-bottom:-8px;">
        <!--会计期间-->
        <el-form-item label="Accounting Interval">
          <el-select ref="fromFPRef" v-model="form.fromFP" style="width: 120px;" placeholder="Please select">
            <el-option
              v-for="(item,index) in fiscalPeriods"
              :key="index"
              :label="fiscalPeriodLabelFun(item)"
              :value="item.uuid"
            />
          </el-select>
        </el-form-item>
        <!--部门-->
        <el-form-item label="OP Dept">
          <office-department-cascader
            v-model="form.departmentIds"
            placeholder="Please input keyword"
            style="width: 160px;"
          />
        </el-form-item>
        <!--销售-->
        <el-form-item label="Sales">
          <cargo-advance-select
            :callback-params="{key:'sales'}"
            :default-value="form.sales"
            :select-type="selectTypeNames.basic_data_User"
            callback-method-type="value"
            placeholder="Please input keyword"
            filterable
            style="width: 160px;"
            @parentCallBack="selectChangeHandler"
          />
        </el-form-item>
        <el-form-item>
          <!--查询-->
          <el-button class="el-margin" type="primary" @click="doSearch">Search</el-button>
          <!--新增明细科目-->
          <el-button class="el-margin" type="primary" @click="newLineItems">New line items</el-button>
          <!--新增统计科目-->
          <el-button class="el-margin" type="primary" @click="newStatisticalItems">New statistical items</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="section" style="flex: 1;padding: 0px;">
      <cargo-ag-grid
        :show-side-bar="false"
        :column-defs="columnDefs"
        :grid-options="gridOptions"
        :grid-params.sync="girdParams"
        :auto-fit-content="false"
        :row-data="rowData"
        style="height: 800px;"
      />
    </div>
    <statement-element-dialog
      :visible="statementElementDialog.visible"
      :atb-dictionary="atbDictionary"
      :account-set="accountSet"
      :elementformula-editable="statementElementDialog.elementformulaEditable"
      :statement-description-uuid="statementElementDialog.statementDescriptionUuid"
      :statement-description="statementElementDialog.statementDescription"
      @close="statementElementDialog.visible=false"
    />
    <element-formula-new-dialog
      :visible="elementFormulaNewDialog.visible"
      :atb-dictionary="atbDictionary"
      :account-set="accountSet"
      :elementformula-editable="elementFormulaNewDialog.elementformulaEditable"
      :statement-description-uuid="elementFormulaNewDialog.statementDescriptionUuid"
      :statement-description="elementFormulaNewDialog.statementDescription"
      @close="elementFormulaNewDialog.visible=false"
    />
    <element-formula-edit-dialog
      :visible="elementFormulaEditDialog.visible"
      :atb-dictionary="atbDictionary"
      :account-set="accountSet"
      :elementformula-editable="elementFormulaEditDialog.elementformulaEditable"
      :statement-element-description-uuid="elementFormulaEditDialog.statementElementDescriptionUuid"
      :statement-element-description="elementFormulaEditDialog.statementElementDescription"
      statement-name="ProfitLossYear"
      @close="elementFormulaEditDialog.visible=false"
    />
  </div>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import officeDepartmentCascader from '@/components/Cargo/Common/officeDepartmentCascader'
import * as statementDescriptionApi from '@/api/financeManage/statementDescription'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getLoading } from '@/utils/utilBaseElement'
import * as NumberUtils from '@/utils/NumberUtils'
import { DocumentManage } from '@/utils/commonUtil'
import ElementFormulaEditDialog from '@/views/cargo/v0/FinanceManage/UsaReport/components/ElementFormulaEditDialog'
import StatementElementDialog from '@/views/cargo/v0/FinanceManage/UsaReport/components/StatementElementDialog'
import ElementFormulaNewDialog from '@/views/cargo/v0/FinanceManage/UsaReport/components/ElementFormulaNewDialog'
import { exportExcelMultiHeader } from '@/utils/tableDataExportUtils'
import { ABC_US } from '@/utils/StrUtils'
import ColumnUtils from '@/utils/ColumnUtils'
import { repareNodeSort } from '@/utils/commonUtil'
import jc from 'json-cycle'

export default {
  name: 'ProfitLossYear',
  components: { cargoAdvanceSelect, officeDepartmentCascader, StatementElementDialog, ElementFormulaEditDialog, ElementFormulaNewDialog },
  props: {
    accountSet: { type: Object, default: null },
    statementDescription: { type: Object, default: null }
  },
  data() {
    return {
      documentManage: new DocumentManage(),
      girdParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          menuTabs: [], // 去掉每列的菜单
          sortable: false // 去掉每列的排序
        },
        suppressContextMenu: false,
        getContextMenuItems: () => {
          const self = this
          return [
            {
              name: 'Export excel',
              action: function() {
                self.exportExcelHandler()
              }
            }
          ]
        }
      },
      rowData: [],
      atbDictionary: {},
      statementElementDialog: {
        visible: false,
        elementformulaEditable: true,
        statementDescriptionUuid: '',
        statementDescription: {}
      },
      elementFormulaNewDialog: {
        visible: false,
        elementformulaEditable: true,
        statementDescriptionUuid: '',
        statementDescription: {}
      },
      elementFormulaEditDialog: {
        visible: false,
        elementformulaEditable: true,
        statementElementDescriptionUuid: '',
        statementElementDescription: {}
      },
      selectTypeNames: TYPE_NAMES,
      form: {
        fromFP: '',
        departmentId: 0,
        departmentIds: [],
        sales: 0
      }
    }
  },
  computed: {
    // 当前会计期间
    currentFiscalPeriod() {
      return this.accountSet ? this.accountSet.currentFiscalPeriod : null
    },
    // 初始会计期间
    initialFiscalPeriod() {
      return this.accountSet ? this.accountSet.initialFiscalPeriod : null
    },
    // 会计期间
    fiscalPeriods() {
      return this.accountSet ? this.accountSet.fiscalPeriod : []
    },
    fiscalPeriod() {
      if (this.fiscalPeriods && this.form.fromFP) {
        return this.fiscalPeriods.find(fp => fp.uuid === this.form.fromFP)
      }
      return null
    },
    yearHeader() {
      if (this.fiscalPeriod) return this.fiscalPeriod.year + '' + this.fiscalPeriod.month
      if (this.currentFiscalPeriod) return this.currentFiscalPeriod.year + '' + this.currentFiscalPeriod.month
      return '202201'
    },
    columnDefs() {
      return [
        { headerName: 'Line No.', field: 'lineNo', width: 90,
          cellStyle: { textAlign: 'center' }
        },
        { headerName: 'Account No.', field: 'elementNo', width: 120, sortable: true,
          cellRenderer: params => {
            return ColumnUtils.accountNoLabelItemRenderer(params.value)
          }
        },
        { headerName: 'Account name', field: 'name', width: 200,
          cellRenderer: params => {
            const methodPath = this.documentManage.getPath('statementColumnDescriptionClickHandler')
            return `<a onclick="${methodPath}('${params.data.uuid}')" style="text-decoration: underline;">${params.value}</a>`
          }
        },
        { headerName: 'Period Actual', field: 'periodActual', width: 160,
          cellStyle: { textAlign: 'right' },
          cellRenderer: params => {
            return this.amountLabelItemRenderer(params.value)
          }
        },
        { headerName: 'YTD Actual', field: 'ytdActual', width: 160,
          cellStyle: { textAlign: 'right' },
          cellRenderer: params => {
            return this.amountLabelItemRenderer(params.value)
          }
        },
        { headerName: 'Period Last Year', field: 'periodLastYear', width: 160,
          cellStyle: { textAlign: 'right' },
          cellRenderer: params => {
            return this.amountLabelItemRenderer(params.value)
          }
        },
        { headerName: 'YTD Last Year', field: 'ytdLastYear', width: 160,
          cellStyle: { textAlign: 'right' },
          cellRenderer: params => {
            return this.amountLabelItemRenderer(params.value)
          }
        },
        { headerName: 'Total Year Last Year', field: 'totalLastYear', width: 160,
          cellStyle: { textAlign: 'right' },
          cellRenderer: params => {
            return this.amountLabelItemRenderer(params.value)
          }
        }
      ]
    },
    excelColumnDefs() {
      return [
        { headerName: 'Line No.', field: 'lineNo', width: 90, hide: false },
        { headerName: 'Account No.', field: 'elementNo', width: 120,
          cellRenderer: params => { return ColumnUtils.accountNoLabelItemRenderer(params.value) + ' ' },
          hide: false
        },
        { headerName: 'Account name', field: 'name', width: 200, hide: false },
        { headerName: 'Period Actual', field: 'periodActual', width: 160,
          cellRenderer: params => { return params.value ? params.value : '' },
          hide: false
        },
        { headerName: 'YTD Actual', field: 'ytdActual', width: 160,
          cellRenderer: params => { return params.value ? params.value : '' },
          hide: false
        },
        { headerName: 'Period Last Year', field: 'periodLastYear', width: 160,
          cellRenderer: params => { return params.value ? params.value : '' },
          hide: false
        },
        { headerName: 'YTD Last Year', field: 'ytdLastYear', width: 160,
          cellRenderer: params => { return params.value ? params.value : '' },
          hide: false
        },
        { headerName: 'Total Year Last Year', field: 'totalLastYear', width: 160,
          cellRenderer: params => { return params.value ? params.value : '' },
          hide: false
        }
      ]
    },
    elementFormulaEditable() {
      if (!this.currentFiscalPeriod || !this.initialFiscalPeriod) {
        return false
      }
      if (this.currentFiscalPeriod.year === this.initialFiscalPeriod.year &&
        this.currentFiscalPeriod.month === this.initialFiscalPeriod.month) {
        return true
      }
      if (this.currentFiscalPeriod.year !== this.initialFiscalPeriod.year && this.currentFiscalPeriod.month === 1) {
        return true
      }
      return false
    }
  },
  watch: {
    accountSet(newVal) {
      if (newVal) {
      }
    }
  },
  beforeMount() {
    const self = this
    this.documentManage.set('statementColumnDescriptionClickHandler', function(data) {
      self.statementColumnDescriptionClickHandler(data)
    })
  },
  methods: {
    fiscalPeriodLabelFun(data) {
      if (data) {
        return data.year + '.' + data.month
      }
      return ''
    },
    selectChangeHandler(params) {
      this.form[params.key] = params.value
    },
    doSearch() {
      const params = {}
      params.accountSetKey = this.accountSet.uuid
      params.statementName = this.statementDescription.statementName
      params.statementDescriptionUuid = this.statementDescription.uuid
      const fromFP = this.fiscalPeriod
      if (fromFP) {
        params.month = fromFP.month
        params.endMonth = fromFP.month
        params.year = fromFP.year
      }
      if (this.form.sales) params.sales = this.form.sales
      if (this.form.departmentId) params.departmentId = this.form.departmentId
      if (this.form.departmentIds.length > 0) {
        const set = new Set()
        for (const item of this.form.departmentIds) {
          for (let i = 1; i < item.length; ++i) {
            set.add(item[i])
          }
        }
        params.departmentIds = [...set].join(',')
      }
      // 重置
      this.gridOptions.api.setColumnDefs(this.columnDefs)
      this.rowData = this.statementDescription.statementElementDescription
      const loading = getLoading()
      statementDescriptionApi.getStatement2UsaReport(params).then(resp => {
        this.getStatementResult(resp)
      }).finally(() => loading.close())
    },
    getStatementResult(resp) {
      const result = resp.data
      if (result && result.atbs && result.atbs instanceof Array) {
        for (const atb of result.atbs) {
          this.atbDictionary[atb.accountTitle] = atb
        }
      }
      if (result && result.dataProvider) {
        this.rowData = result.dataProvider
      }
    },
    amountLabelItemRenderer(value) {
      if (value) {
        return NumberUtils.formatRoundNumber(value, 2)
      }
      return ''
    },
    statementColumnDescriptionClickHandler(value) {
      const elementDescription = this.statementDescription.statementElementDescription.find(element => element.uuid === value)
      this.elementFormulaEditDialog.statementElementDescriptionUuid = elementDescription.uuid
      this.elementFormulaEditDialog.statementElementDescription = elementDescription
      this.elementFormulaEditDialog.elementformulaEditable = true // this.elementFormulaEditable
      this.elementFormulaEditDialog.visible = true
    },
    exportExcelHandler() {
      const columnDefs = []
      this.excelColumnDefs.forEach(column => { if (!column.hide) columnDefs.push({ colDef: column }) })
      let exportFileName = 'Profit And Loss Report Year - Period Analysis to '
      if (this.fiscalPeriod) {
        exportFileName = exportFileName + this.fiscalPeriod.year + this.fiscalPeriod.month
      }
      const multiHeader = []
      const row = []
      columnDefs.forEach(column => { row.push('') })
      row[0] = this.$store.getters.currentOffice.englishName
      multiHeader.push(row)
      const row1 = row.concat()
      row1[0] = 'Profit And Loss Report - Period Analysis to ' + this.fiscalPeriod.year + this.fiscalPeriod.month
      multiHeader.push(row1)
      const row2 = row.concat()
      row2[0] = 'Printed by ' + this.$store.getters.userInfo.englishName + ' ' + this.$moment(new Date()).format('D-MMM-YY HH:mm:ss A')
      multiHeader.push(row2)
      const col = columnDefs.length
      const colName = ABC_US[col - 1]
      const merges = ['A1:' + colName + '1', 'A2:' + colName + '2', 'A3:' + colName + '3']
      const nodes = []
      this.gridOptions.api.forEachNode(node => { nodes.push(node) })
      repareNodeSort(nodes)
      const rows = nodes.map(item => item.data)
      const newRows = jc.decycle(rows)
      let rowCount = 1
      newRows.forEach(row => { row.lineNo = rowCount; rowCount++ }) // 重置Line No
      exportExcelMultiHeader(multiHeader, merges, exportFileName, newRows, columnDefs)
    },
    defaultFpUuid() {
      if (this.form.fromFP) return
      if (this.fiscalPeriods) {
        this.form.fromFP = this.fiscalPeriods[0].uuid
      }
    },
    // 新增明细科目
    newLineItems() {
      this.statementElementDialog.elementformulaEditable = true
      this.statementElementDialog.statementDescriptionUuid = this.statementDescription.uuid
      this.statementElementDialog.statementDescription = this.statementDescription
      this.statementElementDialog.visible = true
    },
    // 新增统计科目
    newStatisticalItems() {
      this.elementFormulaNewDialog.elementformulaEditable = true
      this.elementFormulaNewDialog.statementDescriptionUuid = this.statementDescription.uuid
      this.elementFormulaNewDialog.statementDescription = this.statementDescription
      this.elementFormulaNewDialog.visible = true
    }
  }
}
</script>

<style scoped>

</style>
